// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22yuz","questions":"styles_questions__3bWXe","footer":"styles_footer__2gzN8"};